import { Injectable } from '@angular/core';
import { PincodeDetailsData } from '../interfaces/pincode';
import { Observable } from 'rxjs';
import { ApiService } from '../../common/api.service';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root'
})
export class PincodeDetailsService extends ApiService{

  public fetchPincodeDetails(
    pincode: string
  ): Observable<PincodeDetailsData> {
    return this.get<PincodeDetailsData>(
      this.replacePathInfo(ROUTES.PINCODE_V2, {
        pincode: pincode,
      }))
  }
}
